import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="descriptionbox-navigator">
            <div className="descriptionbox-nav-box">Descripción</div>
            <div className="descriptionbox-nav-box fade">Reseñas (122)</div>
        </div>
        <div className="descriptionbox-description">
            <p> Descripcion de prueba para el back 322 GG  </p>
            <p>
                Segundo Descripcion de prueba para el back 322 GG 222 segundo
            </p>
        </div>

      
    </div>
  )
}

export default DescriptionBox
